const masterIndentStatusList = [
  {
    id: 1,
    name: 'created',
    label: 'Created',
    pre_leg: 1,
  },
  {
    id: 2,
    name: 'freight_forwarder_accepted',
    label: 'Freight Forwarder Accepted',
    pre_leg: 1,
  },
  {
    id: 3,
    name: 'freight_forwarder_rejected',
    label: 'Freight Forwarder Rejected',
    pre_leg: 1,
  },
  {
    id: 4,
    name: 'container_assigned',
    label: 'Container Assigned',
    pre_leg: 1,
  },
  {
    id: 5,
    name: 'cancelled',
    label: 'Cancelled',
  },

  // road leg
  {
    id: 6,
    name: 'on_road',
    label: 'On Road',
  },
  {
    id: 7,
    name: 'road_delivered',
    label: 'Road: Delivered',
  },
  {
    id: 8,
    name: 'on_ocean',
    label: 'On Ocean',
  },
  {
    id: 9,
    name: 'delivered',
    label: 'Delivered',
  },
  {
    id: 10,
    name: 'ocean_delivered',
    label: 'Ocean: Delivered',
  },
  {
    id: 11,
    name: 'delivered_at_border',
    label: 'Delivered At Border',
  },
  {
    id: 12,
    name: 'created_without_ff',
    label: 'Created',
    pre_leg: 1,
  },
  {
    id: 13,
    name: 'on_air',
    label: 'On Air',
  },
  {
    id: 14,
    name: 'air_delivered',
    label: 'Air: Delivered',
  },
  {
    id: 15,
    name: 'shipment_booked',
    label: 'Shipment Booked',
  },
  {
    id: 16,
    name: 'on_rail',
    label: 'On Rail',
  },
  {
    id: 17,
    name: 'rail_delivered',
    label: 'Rail: Delivered',
  },
];

const masterStatusGrouping = {
  1: [1, 12],
  2: [2],
  3: [3],
  4: [4],
  5: [5],
  6: [6],
  7: [7],
  8: [8],
  9: [9],
  10: [10],
  11: [11],
  13: [13],
  14: [14],
  15: [15],
};

const masterIndentStatusMapping = masterIndentStatusList.reduce((acc, curval) => {
  acc[curval.name] = curval.id;
  return acc;
}, {});

const roadToMasterStatusMap = {
  0: -1,
  1: -1,
  2: -1,
  3: -1,
  4: -1,
  5: 6,
  6: 6,
  7: 7,
  8: 5,
  16: 6,
  17: 6,
  18: 6,
  20: 6,
  21: 6,
  22: 6,
  23: 7,
  24: 6,
  25: 6,
  26: 6,
  27: 6,
};

const roadToMasterStatusMapImport = {
  0: -1,
  1: -1,
  2: -1,
  3: -1,
  4: -1,
  5: 6,
  6: 6,
  7: 6,
  8: 5,
  16: -1,
  17: -1,
  18: -1,
  20: -1,
  21: -1,
  22: -1,
  23: 6,
  24: -1,
  25: -1,
  26: -1,
  27: -1,
};

module.exports = {
  masterIndentStatusList,
  masterIndentStatusMapping,
  roadToMasterStatusMap,
  roadToMasterStatusMapImport,
  masterStatusGrouping,
};

